import { Chat } from '@/features/account/components/Chat'
import { GenericHero } from '@/features/entrypoint/components/ContactPage/GenericHero'
import { ContactInfo } from '@/features/entrypoint/components/ContactPage/ContactInfo'
import { SprinklrForm } from '@/features/entrypoint/components/ContactPage/SprinklrForm'
import { type ComponentProps } from 'react'
import { type CMSPage } from '@/features/cms/components/CMS/CMSPage'
import { PartialCMSPageWithHeaderAndAnnouncement } from '@/features/cms/components/CMS/PartialCMSPageWithHeaderAndAnnouncement'

export const ContactPage = ({ cmsData }: ComponentProps<typeof CMSPage>) => {
  return (
    <div>
      <PartialCMSPageWithHeaderAndAnnouncement cmsData={cmsData} />
      <GenericHero />
      <SprinklrForm />
      <ContactInfo />
      <Chat />
    </div>
  )
}
